import {Formik} from "formik";
import CustomTabMenu from "../component/CustomTabMenu";
import {danhSachTab} from "./Constant";
import {localStorageItem} from "../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../auth/core/_consts";
import {useEffect, useState} from "react";
import {tab} from "../appContext/AppContextModel";

type TongHopPhieuProps = {
    listMenu: any;
};

export const TongHopPhieu = ({listMenu}: TongHopPhieuProps) => {
    const listTabs = listMenu?.[0]?.subs.find((x: any) => x?.uri === window.location.pathname)?.subs;
    const [columns, setColumns] = useState<any>([]);

    useEffect(() => {
      const listTab: any = [];

      danhSachTab(listTabs).forEach((item) => {
        if (typeof item === "object") listTab.push(item)
      })
      setColumns(listTab)

    }, [])
    return (
        <Formik<any> initialValues={{}} onSubmit={() => {
        }}>
            <CustomTabMenu
                childrenTab={true}
                danhsachTabs={columns}
                className="spaces pl-0"
            />
        </Formik>
    );
};

export default TongHopPhieu;